// src/AboutPopUp.js
import React from "react";
import "./AboutPopUp.css";

function AboutPopUp({ onClose, title, content, videoIndex }) {
  // Predefined arrays for desktop and mobile videos.
  const desktopVideos = [
    require("./assets/video.mp4"),  // Commercial General Liability (Desktop version) //
    require("./assets/video2.mp4"), // Bonds 25,000 (Desktop version) //
    require("./assets/video3.mp4"), // Commercial Auto (Desktop version) // 
    require("./assets/video4.mp4"),
    require("./assets/video5.mp4"), // Umbrella (Desktop version) //
  ];
  const mobileVideos = [
    require("./assets/vertical.mp4"),  // Commercial General Liability (Mobile Version) //
    require("./assets/vertical2.mp4"),
    require("./assets/vertical3.mp4"),
    require("./assets/vertical4.mp4"),
    require("./assets/vertical5.mp4"),
  ];

  // Adjust index to be zero-based.
  const index =
    videoIndex && videoIndex > 0 && videoIndex <= desktopVideos.length
      ? videoIndex - 1
      : 0;

  const desktopVideoUrl = desktopVideos[index];
  const mobileVideoUrl = mobileVideos[index];

  return (
    <div className="about-popup-overlay" onClick={onClose}>
      <div
        className="about-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="popup-close-btn" onClick={onClose}>
          ×
        </button>
        <div className="popup-video-full">
          {/* Desktop video */}
          <video
            className="desktop-video embedded-video"
            src={desktopVideoUrl}
            controls
            loop
            muted
            autoPlay
          />
          {/* Mobile video */}
          <video
            className="mobile-video embedded-video"
            src={mobileVideoUrl}
            controls
            loop
            muted
            autoPlay
          />
        </div>
        <div className="popup-lower-content">
          <h2>{title}</h2>
          <p>{content}</p>
        </div>
      </div>
    </div>
  );
}

export default AboutPopUp;